import styled from 'styled-components';

export const UploadedPointContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
`;
